/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { AUTH_SUCCESS, AUTH_FAILURE, AUTH_CLEAR } from 'actions/auth';

import {
  SET_STATUS,
  REGISTER_FREELANCE_COMPANY_SUCCESS,
  UPDATE_FREELANCE_COMPANY_SUCCESS,
  REGISTER_FREELANCE_SUCCESS,
} from 'actions/paymentMethod';

export const STATUS = {
  SELECT_METHOD: 'SELECT_METHOD',
  REGISTER_COMPANY: 'REGISTER_COMPANY',
  CREATE_COMPANY: 'CREATE_COMPANY',
  REGISTER_FREELANCE: 'REGISTER_FREELANCE',
  REGISTER_COOL_COMPANY: 'REGISTER_COOL_COMPANY',
  HAS_PAYMENT_METHOD: 'HAS_PAYMENT_METHOD',
};

const initialState = {
  status: STATUS.SELECT_METHOD,
};

/**
 * This is the signup reducer. It listens for actions and updates the signup object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type, payload }) {
  switch (type) {
    case SET_STATUS:
      return {
        ...state,
        status: payload.status,
      };

    case REGISTER_FREELANCE_COMPANY_SUCCESS:
      return {
        ...state,
        status: STATUS.CREATE_COMPANY,
      };

    case REGISTER_FREELANCE_SUCCESS:
    case UPDATE_FREELANCE_COMPANY_SUCCESS:
      return {
        ...state,
        status: STATUS.HAS_PAYMENT_METHOD,
      };

    case AUTH_SUCCESS:
      return {
        ...state,
        status: payload.has_payment_method ? STATUS.HAS_PAYMENT_METHOD : null,
      };

    case AUTH_FAILURE:
    case AUTH_CLEAR:
      return initialState;

    default:
      return state;
  }
}
